import { render, staticRenderFns } from "./DeliverableContactPlaceholder.vue?vue&type=template&id=54cd723d&"
import script from "./DeliverableContactPlaceholder.vue?vue&type=script&lang=js&"
export * from "./DeliverableContactPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports